import 'globals';

(function (window, PageLoadedQueue) {
    PageLoadedQueue.addFunction(function() {
        window.lazyLoadObject = new LazyLoad({
            elements_selector: '.img-fluid'
        });
    });
})(window, window.PageLoadedQueue);
